const CHAT_EVENTS = {
  CREATE_CHAT: 'chat:create',
  JOIN_CHAT: 'chat:join',
  JOIN_GROUP: 'group:join',
  LIST_CHAT: 'chat:list',
  NEW_CHAT: 'chat:new',
  SEND_MESSAGE: 'message:send',
  SYNC_MESSAGES: 'message:sync',
  VOICE_SEND: 'send:voice',
  USER_STATUS: 'user:status',
  CHAT_FINISHED: 'conversation:finished',
  VERIFICATION_REQUEST: 'verification:request',
  VERIFICATION_RESPOND: 'verification:respond',
};

export default CHAT_EVENTS;
